import { useAppSelector } from 'hooks/reduxHooks'
import TextButton from 'LuxKit/Button/TextButton'
import useReopenLoyaltyAccount, { reopenLoyaltyAccountMessages } from 'loyalty/hooks/useReopenLoyaltyAccount'
import { useIntl } from 'react-intl'

function LoyaltyPurchasePointsReopenAccountCta() {
  const intl = useIntl()
  const reopenAccount = useReopenLoyaltyAccount()
  const reopening = useAppSelector(state => !!state.loyalty.reopeningAccount)

  return <TextButton kind="primary" size="large" onClick={reopenAccount} disabled={reopening}>
    {intl.formatMessage(reopenLoyaltyAccountMessages.cta)}
  </TextButton>
}

export default LoyaltyPurchasePointsReopenAccountCta
